import {getCookieByName, setCookie, useConfig, useRouter} from "@/plugins/obscore";
import {postRequest} from "@/plugins/axioscalls";

export default {
    state: {
        _token: null,
        isAuthenticated: false,
    },
    getters: {
        token() {
            if (!this._token)
                this._token = getCookieByName("token")
            this.isAuthenticated = !!this._token;
            return this._token
        },
    },
    actions: {
        prepareRequest(config,isPublic) {
            if(!isPublic){
                config.headers = config.headers ? config.headers : {}
                config.headers.Authorization = "Bearer " + this.token
            }
            config.headers.Accept = 'application/json'
            return config
        },
        async login(params) {
            let store = this;
            const config = useConfig()
            await postRequest(config.auth.loginURL, params.value, {
                withCredentials: true,
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            })
                .then((data) => {
                    store._token = data.data.token
                    setCookie('token', store._token)
                    if (store.lastVisitedRoute) {
                        useRouter().push(store.lastVisitedRoute)
                    } else {
                        useRouter().push("/")
                    }
                })
        },
        logout() {
            this._token = null
            this.isAuthenticated = false
            setCookie('token', null)
        }
    }
}